<template>
  <div id="sys_set_main" :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img">
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">安全中心</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/发布.png" class="nav-img none">
      </div>
    </div>

    <div class="menu-block">
      <div class="ub ub-pc menu-item" @click="bindTel()">
        <div class="ub-ae ub-f1 menu-item-name">绑定手机号码</div>
      </div>

      <div class="menu-line"></div>

      <div class="ub ub-pc menu-item" @click="login()">
        <div class="ub-ae ub-f1 menu-item-name">找回原来账号</div>
      </div>
    </div>

    <bindtel ref="myBindTel"></bindtel>
    <login ref="myLogin"></login>
  </div>
</template>

<script>
import { setTimeout } from "timers";
import Login from "../../components/Login.vue";
import Bind from "../../components/BindTel.vue";
import * as tool from "../../api/common";

export default {
  components: {
    login: Login,
    bindtel: Bind
  },

  data() {
    return {
      data_name: "xxxx",
      theme_dark: false
    };
  },

  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
  },

  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    bindTel() {
      var h =
        '<div style="font-size: 1em;line-height: 1.6em;color: #888;">为了防止您的信息丢失，请绑定手机号码，后续可通过该手机号码找回丢失的信息。平台郑重承诺，在未经您本人同意的情况下，我们不会泄露您的任何信息。</div>';
      this.$refs.myBindTel.show(h, {
        type: "alert",
        confirmText: "立即绑定",
        titleText: "绑定手机号码",
        data: ""
      });
    },
    login() {
      var h =
        '<div style="font-size: 1em;line-height: 1.6em;color: #888;">登陆失败，请退出重新进入</div>';
      this.$refs.myLogin.show(h, {
        type: "alert",
        confirmText: "立即找回",
        titleText: "找回账号",
        data: ""
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-block {
  padding: 0 0.8rem;
  background-color: #fff;
  .menu-item {
    height: 3rem;
    .menu-item-name{
      font-size: .95rem;
    }
  }
  .menu-line {
    border-top: 1px solid #EFEFEF;
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2f2e33;
  .menu-block {
    background-color: #2c2b30;
    .menu-item-name{
      color: #DFDFDF;
    }
  }
  .menu-line {
    border-top: 1px solid #404040;
  }
}
</style>